import {put, call , takeLatest} from "redux-saga/effects"
import {actions} from './Reducer'
import {getArtisansReportsSuccessAction , setArtisansReportsCountAction , setArtisansReportsIsLoadingAction} from "./Actions"
import * as Api from "../../artisans/Api"


function* getArtisansReports({payload}){

    const defData = {
        offset: 0,
        size: 10,
        searchTerm: "",
        filterBy: [],
        filterCountry: "",
        sort: "businessName",
        dir: "asc",
      };

    const body = {...defData , ...payload}

    try {
        yield put(setArtisansReportsIsLoadingAction(true))
        const response  = yield call(Api.getArtisans , body)
        const { data } = response;
        const count = data[0].count;
        const users = data[0].content;

        yield put(getArtisansReportsSuccessAction(users))
        yield put(setArtisansReportsCountAction(count))

    }catch(error){
        console.log(error)
    }finally{
        yield put(setArtisansReportsIsLoadingAction(false))
    }
}

export default function*(){
    yield takeLatest(actions.REPORTS_GET_ARTISANS , getArtisansReports)
}